import { SEARCH_APPEARS_ON_FILTER_FIELD } from '@disco/constants/search'
import { formatDuration } from '@disco/utils/time-utils'

import { FilterConfig, FilterDefinition } from 'types/filter-page'

import BooleanForm from './filter-forms/boolean'
import DateForm from './filter-forms/date'
import DropdownForm from './filter-forms/dropdown'
import DurationForm from './filter-forms/duration'
import GroupForm from './filter-forms/group'
import NumberForm from './filter-forms/number'
import TagsForm from './filter-forms/tags'
import TextForm from './filter-forms/text'
import YearForm from './filter-forms/year'
import { formatBadgeLabel } from './utils'

/**
 * Shared "Appears on" (playlists count) filter, reused by the filters dropdown
 * and the column-header filter so both edit the same `filters` entry.
 */
export const APPEARS_ON_FILTER_DEFINITION: FilterDefinition = {
  label: 'Appears on',
  type: 'number',
  field: SEARCH_APPEARS_ON_FILTER_FIELD,
  isNew: true,
}

export const discoDefaultMetadata = [
  'Artist',
  'Title',
  'Album',
  'BPM',
  'Release Date',
  'Composer',
  'Genre',
  'Grouping',
  'Client Note',
  'Comment',
  'Internal Note',
  'Lyrics',
  'Year',
]

export const filterDataTypes: FilterConfig[] = [
  {
    id: 'text',
    component: TextForm,
    badgeLabel: formatBadgeLabel,
  },
  {
    id: 'boolean',
    component: BooleanForm,
    badgeLabel: formatBadgeLabel,
  },
  {
    id: 'tags',
    component: TagsForm,
    badgeLabel: formatBadgeLabel,
  },
  {
    id: 'date',
    component: DateForm,
    badgeLabel: formatBadgeLabel,
  },
  {
    id: 'partial_date',
    component: DateForm,
    badgeLabel: formatBadgeLabel,
  },
  {
    id: 'year',
    component: YearForm,
    badgeLabel: formatBadgeLabel,
  },
  {
    id: 'number',
    component: NumberForm,
    badgeLabel: formatBadgeLabel,
  },
  {
    id: 'duration',
    component: DurationForm,
    badgeLabel: state => {
      if (!state.value) return null
      const from = formatDuration(state.value[0], 'm:ss')
      const to =
        state.value[1] === Infinity
          ? '∞'
          : formatDuration(state.value[1], 'm:ss')
      return formatBadgeLabel({
        ...state,
        value: [from, to],
        operator: state.operator,
      })
    },
  },
  {
    id: 'group',
    component: GroupForm,
    badgeLabel: formatBadgeLabel,
  },
  {
    id: 'dropdown_single',
    component: DropdownForm,
    badgeLabel: formatBadgeLabel,
  },
  {
    id: 'dropdown_multi',
    component: DropdownForm,
    badgeLabel: formatBadgeLabel,
  },
]
